import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';
import { credentialInstructions, getProviderFormLabel } from '../utils';

const SignInPaylocityCredential = ({
  provider,
  isLoading,
  onSubmit,
  handleClick,
  client,
}: RegisterImplementationProps) => {
  const instructions = credentialInstructions(client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      onSubmit={onSubmit}
      fieldNames={['companyId', 'username', 'password']}
      render={({ companyId, username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                value={companyId.value}
                onChange={(event) =>
                  companyId.onChange(
                    event.target.value,
                    !event.target.validity.valid,
                  )
                }
                invalid={companyId.invalid}
                label="Company ID"
                id="companyId"
                minLength={4}
                maxLength={9}
              />
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Username"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://access.paylocity.com/ForgotPassword'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Use an API Token instead
              </SwitchImplementationButton>
            )}
            <LoaderButton
              isLoading={isLoading}
              disabled={
                isLoading ||
                !!companyId.invalid ||
                !companyId.value ||
                !username.value ||
                !password.value
              }
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default SignInPaylocityCredential;
